import React from 'react';
import { AlertTriangle, X } from 'lucide-react';
import { DeleteConfirmation } from '../types';

interface ConfirmDialogProps {
  confirmation: DeleteConfirmation;
}

const ConfirmDialog: React.FC<ConfirmDialogProps> = ({ confirmation }) => {
  if (!confirmation.isOpen) return null;

  return (
    <div className="fixed inset-0 bg-slate-900/60 backdrop-blur-sm flex items-center justify-center z-50 p-4 transition-all">
      <div className="bg-white rounded-2xl p-6 max-w-md w-full shadow-2xl border border-slate-100 transform transition-all">
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center">
            <AlertTriangle className="h-6 w-6 text-red-500 mr-2" />
            <h3 className="text-lg font-bold text-slate-800">
              {confirmation.title}
            </h3>
          </div>
          <button
            onClick={confirmation.onCancel}
            className="text-slate-400 hover:text-slate-600 p-1 bg-slate-50 hover:bg-slate-100 rounded-lg transition-colors"
          >
            <X className="h-5 w-5" />
          </button>
        </div>
        
        <p className="text-slate-600 mb-6 leading-relaxed">
          {confirmation.message}
        </p>
        
        <div className="flex justify-end space-x-3">
          <button
            onClick={confirmation.onCancel}
            className="px-4 py-2 text-sm font-semibold text-slate-700 bg-white border border-slate-300 rounded-xl hover:bg-slate-50 focus:outline-none focus:ring-2 focus:ring-slate-500/20 transition-all"
          >
            Cancel
          </button>
          <button
            onClick={confirmation.onConfirm}
            className="px-4 py-2 text-sm font-semibold text-white bg-red-600 border border-transparent rounded-xl hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500/20 shadow-sm hover:shadow transition-all"
          >
            Delete
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDialog;
